import type { BaseModelAttributes } from "./base";
import { I18nLabels } from "./common";
import { Locale } from "./locale";

export enum Gender {
  MALE = "MALE",
  FEMALE = "FEMALE",
}

export const GenderLabels: I18nLabels<Gender> = {
  [Gender.MALE]: { [Locale.ZH_CN]: "男性", [Locale.EN_US]: "Male" },
  [Gender.FEMALE]: { [Locale.ZH_CN]: "女性", [Locale.EN_US]: "Female" },
};

export enum AgeGroup {
  CHILD = "CHILD",
  YOUNG_ADULT = "YOUNG_ADULT",
  ADULT = "ADULT",
  SENIOR = "SENIOR",
}

export const AgeGroupLabels: I18nLabels<AgeGroup> = {
  [AgeGroup.CHILD]: { [Locale.ZH_CN]: "儿童", [Locale.EN_US]: "Child" },
  [AgeGroup.YOUNG_ADULT]: { [Locale.ZH_CN]: "青年", [Locale.EN_US]: "Young Adult" },
  [AgeGroup.ADULT]: { [Locale.ZH_CN]: "成年", [Locale.EN_US]: "Adult" },
  [AgeGroup.SENIOR]: { [Locale.ZH_CN]: "老年", [Locale.EN_US]: "Senior" },
};

export enum Language {
  MANDARIN = "MANDARIN",
  CANTONESE = "CANTONESE",
  ENGLISH = "ENGLISH",
}

export const LanguageLabels: I18nLabels<Language> = {
  [Language.MANDARIN]: { [Locale.ZH_CN]: "普通话", [Locale.EN_US]: "Mandarin" },
  [Language.CANTONESE]: { [Locale.ZH_CN]: "粤语", [Locale.EN_US]: "Cantonese" },
  [Language.ENGLISH]: { [Locale.ZH_CN]: "英语", [Locale.EN_US]: "English" },
};

export enum VoiceType {
  SYSTEM = "SYSTEM",
  USER_UPLOAD = "USER_UPLOAD",
}

export const VoiceTypeLabels: I18nLabels<VoiceType> = {
  [VoiceType.SYSTEM]: { [Locale.ZH_CN]: "系统音色", [Locale.EN_US]: "System Voice" },
  [VoiceType.USER_UPLOAD]: { [Locale.ZH_CN]: "个人音色", [Locale.EN_US]: "Custom Voice" },
};

export enum TtsProvider {
  MINIMAX = "MINIMAX",
  AZURE = "AZURE",
  ELEVENLABS = "ELEVENLABS",
}

export const TtsProviderLabels: I18nLabels<TtsProvider> = {
  [TtsProvider.MINIMAX]: { [Locale.ZH_CN]: "MiniMax", [Locale.EN_US]: "MiniMax" },
  [TtsProvider.AZURE]: { [Locale.ZH_CN]: "Azure", [Locale.EN_US]: "Azure" },
  [TtsProvider.ELEVENLABS]: { [Locale.ZH_CN]: "ElevenLabs", [Locale.EN_US]: "ElevenLabs" },
};

export interface IDialogueToneEmotion {
  emotionCode: string;
  emotionDesc: string;
  previewAudioUrl?: string;
}

export interface IDialogueTone extends BaseModelAttributes {
  seq: number;
  gender: Gender;
  genderDesc: string;
  ageGroup: AgeGroup;
  ageGroupDesc: string;
  language: Language;
  languageDesc: string;
  emotions: IDialogueToneEmotion[];
  code: string;
  desc: string;
  previewAudioUrl?: string;
  coverImageUrl?: string;
  ttsProvider: TtsProvider;
  allowPause: boolean;
  categoryCode?: string;
  userId?: string;
  voiceType: VoiceType;
  originalFileName?: string;
  duration?: number;
}

export interface CreateDialogueToneRequest {
  seq: number;
  gender: Gender;
  genderDesc: string;
  ageGroup: AgeGroup;
  ageGroupDesc: string;
  language: Language;
  languageDesc: string;
  emotions: IDialogueToneEmotion[];
  code: string;
  desc: string;
  previewAudioUrl?: string;
  coverImageUrl?: string;
  ttsProvider: TtsProvider;
  allowPause?: boolean;
  categoryCode?: string;
}

export interface UpdateDialogueToneRequest {
  seq?: number;
  gender?: Gender;
  genderDesc?: string;
  ageGroup?: AgeGroup;
  ageGroupDesc?: string;
  language?: Language;
  languageDesc?: string;
  emotions?: IDialogueToneEmotion[];
  code?: string;
  desc?: string;
  previewAudioUrl?: string;
  coverImageUrl?: string;
  ttsProvider?: TtsProvider;
  allowPause?: boolean;
  categoryCode?: string;
}

export interface DialogueToneQuery {
  search?: string;
  gender?: Gender;
  ageGroup?: AgeGroup;
  language?: Language;
  ttsProvider?: TtsProvider;
  categoryCode?: string;
}

export interface CreateUserVoiceRequest {
  name: string;
  desc?: string;
  previewAudioUrl: string;
  originalFileName: string;
  duration?: number;
  gender?: Gender;
  genderDesc?: string;
  ageGroup?: AgeGroup;
  ageGroupDesc?: string;
}

export interface UpdateUserVoiceRequest {
  name?: string;
  desc?: string;
  previewAudioUrl?: string;
  originalFileName?: string;
  duration?: number;
  gender?: Gender;
  genderDesc?: string;
  ageGroup?: AgeGroup;
  ageGroupDesc?: string;
}

export interface UserVoiceQuery {
  search?: string;
}
